import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var publicCourseRes;
export const publicCourseTodo = createAsyncThunk('publicCourse', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/update_course_availability',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "course_id": data.course_id,
                "course_code": data.course_code,
                "course_availability": data.course_availability,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return publicCourseRes = res.data
    } catch (error) {
        return publicCourseRes = error.response.data
    }
})